import { FormHelperText, Grid, InputAdornment, TextField } from "@mui/material";
import { useState, useEffect } from "react";
import { UpdateMenuFlag } from "../../actions";
import setToast from '../../helpers/toaster.helper';
import { UserService } from '../../services/UserService';
import PasswordRequirements from '../login/password-requriements.component';
import ButtonComponent from '../shared/button/button.component';
import { ActionLabels, appNote, buttonLabels, pageTitles, ToasterTexts } from '../shared/constants';
import DisplayContent from '../shared/display-content.component';
import { validateForm } from '../shared/form-validation';
import { ToasterType } from '../shared/toaster/toaster.model';
import { AppRoutes } from "../routes/route.path";
import { setHeaderTitle } from "../../helpers/header.helper";
import { BurgerMenuIcon, HidePassword, ShowPassword, SuccessIcon } from "../../icon";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import * as selector from "../../selectors/selectors"
import { useDispatch } from "react-redux";

const ChangePassword = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const IsDarkMode: boolean = useSelector(selector.isDarkMode)
    const IsTeamsApp: boolean = useSelector(selector.isTeamsApp)
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [errors, setErrors] = useState({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
    });
    const [isSuccess, setIsSuccess] = useState(false);
    const [showPasswordReq, setShowPasswordReq] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setHeaderTitle(pageTitles.CHANGE_PASSOWRD)
    }, [])

    const handleChange = (name: any, value: any) => {

        validateForm({ [name]: value }, (Errors) => {
            setErrors({ ...errors, ...Errors });
        });
    };

    const changePassword = (event: any) => {
        event.preventDefault();
        if (
            validateForm(
                {
                    currentPassword: currentPassword,
                    newPassword: {
                        newPassword: newPassword,
                        oldPassword: currentPassword,
                    },
                    confirmPassword: {
                        newPassword: newPassword,
                        confirmPassword: confirmPassword,
                    },
                },
                (Errors) => {
                    setErrors({ ...errors, ...Errors });
                }
            )
        ) {
            setIsLoading(true)
            const data = {
                newPassword: newPassword,
                oldPassword: currentPassword,
            };
            UserService.changePassword(data)
                .then((res) => {
                    setIsSuccess(true)
                    setIsLoading(true)
                    setErrors({ ...errors, currentPassword: "", newPassword: "", confirmPassword: "" })
                    setCurrentPassword("")
                    setNewPassword("")
                    setConfirmPassword("")
                    setToast(ToasterTexts.CHANGE_PASSWORD_SUCCESS, ToasterType.SUCCESS);
                })
                .catch((error) => {
                    setToast(error.response.data.message, ToasterType.DANGER);
                    setErrors({ ...errors, currentPassword: error.response.data.message, newPassword: "", confirmPassword: "" })
                    setIsLoading(false)
                });
        }
    };

    const isFormValid = () => {
        if (
            currentPassword !== newPassword &&
            !errors.confirmPassword &&
            !errors.currentPassword &&
            !errors.newPassword &&
            !!currentPassword &&
            !!newPassword &&
            !!confirmPassword
        ) {
            return false;
        }
        else return true;
    }
    // const showPasswordRequired = () => {
    //     setShowPasswordReq(!showPasswordReq)
    // };

    const onClickShowPassword = () => {
        setShowPassword(!showPassword)
    }
    const onClickShowNewPassword = () => {
        setShowNewPassword(!showNewPassword)
    }
    const onClickShowConfirmPassword = () => {
        setShowConfirmPassword(!showConfirmPassword)
    }
    const handleCancel = () => {
        setCurrentPassword("");
        setConfirmPassword("");
        setNewPassword("");
        navigate(AppRoutes.DASHBOARD);
    }

    return (
        <div className={`w-p-100 ${IsDarkMode ? "bg-color-primary-background" : "bg-color-profile-primary-background"} ${IsMobileDevice ? "h-p-90" : "d-flex h-p-100 o-y-scroll"} ${(IsMobileDevice && IsTeamsApp) && "o-y-scroll"}`}>
            {IsMobileDevice && (
                <div className="d-flex w-fill px-2 p-absolute mt-2">
                    <span className="p-absolute my-auto" style={{ zIndex: 100 }} onClick={(e) => { e.stopPropagation(); UpdateMenuFlag(dispatch, true) }}>
                        <BurgerMenuIcon />
                    </span>
                    <span className={"h1 ml-4 color-header-title-font"}>
                        {pageTitles.CHANGE_PASSOWRD}
                    </span>
                </div>
            )}
            <div
                className={`${IsMobileDevice
                    ? "paper-background h-p-100"
                    : `${!isSuccess ? "mx-p-12" : "mx-p-20"} settings-paper-border ${IsDarkMode ? "bg-color-sidebar-bg" : "bg-color-profile-changepassword-box-border"} br-4 my-auto  w-fill `
                    } ${!isSuccess ? " h-fit d-flex" : "h-v-50 d-flex"} `}
            >
                {!isSuccess ? (
                    <form noValidate autoComplete="no"
                        className={`${IsMobileDevice ? "" : "w-fill"}`}
                        onSubmit={changePassword}>
                        <Grid container className="p-1" >
                            <Grid
                                container
                                direction="row"
                                spacing={0}
                                className={`${IsMobileDevice ? "w-p-100 mx-auto mt-2" : " "
                                    }`}
                            >
                                <Grid
                                    item
                                    xs={IsMobileDevice ? 12 : 6}
                                    className={`${IsMobileDevice ? "px-4 " : " px-4"}  `}
                                >
                                    <>
                                        {!IsMobileDevice}
                                        <div
                                            className={`${IsMobileDevice ? "mt-5 h4" : IsTeamsApp ? "mt-2 mb-3" : "mt-4 mb-3"} h2`}
                                        >
                                            <PasswordRequirements
                                                passwordCheck={newPassword}
                                                IsMobileDevice={IsMobileDevice}
                                            />
                                        </div>
                                    </>
                                </Grid>
                                <Grid item xs={IsMobileDevice ? 12 : 6} className={`${IsMobileDevice ? "px-4 mt-3" : IsTeamsApp ? "py-4 pr-4" : "py-4 pr-4"} `} >
                                    <div className={`${IsMobileDevice ? "h4 mb-1" : "h5-regular"} ${IsDarkMode ? "" : "color-changepassword-fields-heading"} `}>Current Password *</div>
                                    <TextField
                                        autoFocus
                                        required
                                        type={showPassword ? "text" : "password"}
                                        fullWidth
                                        name="currentPassword"
                                        value={currentPassword}
                                        onChange={(e) => {
                                            handleChange(e.target.name, e.target.value); setCurrentPassword(e.target.value)
                                        }
                                        }
                                        variant="outlined"
                                        inputProps={{ maxLength: 20 }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position='end' onClick={onClickShowPassword} className="c-pointer">
                                                    {showPassword ? <HidePassword /> : <ShowPassword />}
                                                </InputAdornment>
                                            )
                                        }}
                                        FormHelperTextProps={{
                                            className: `h6 ${IsMobileDevice && "h5"}`,
                                        }}
                                        size="small"
                                        className="disableEdgeIcon"
                                    />
                                    <FormHelperText className={` h5 color-primary-danger t-align-right ${errors.currentPassword ? "" : "mb-3"} `}>
                                        {errors.currentPassword}
                                    </FormHelperText>
                                    <div className={`${IsMobileDevice ? "h4 mb-1" : "h5-regular"} ${IsDarkMode ? "" : "color-changepassword-fields-heading"} `}>New Password * </div>
                                    <TextField
                                        type={showNewPassword ? "text" : "password"}
                                        required
                                        fullWidth
                                        name="newPassword"
                                        value={newPassword}
                                        onChange={(e) => {
                                            handleChange(e.target.name, e.target.value); setNewPassword(e.target.value)
                                        }}
                                        variant="outlined"
                                        inputProps={{ maxLength: 20 }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position='end' onClick={onClickShowNewPassword} className="c-pointer">
                                                    {showNewPassword ? <HidePassword /> : <ShowPassword />}
                                                </InputAdornment>
                                            )
                                        }}
                                        FormHelperTextProps={{
                                            className: `h6 ${IsMobileDevice && "h5"}`,
                                        }}
                                        size="small"
                                        className="disableEdgeIcon"
                                    />
                                    <FormHelperText className={` h5 color-primary-danger t-align-right ${errors.newPassword ? "" : "mb-3"} `}>
                                        {!!newPassword && newPassword === currentPassword ? "Current password and new password should be different." : `${errors.newPassword}`}
                                    </FormHelperText>
                                    <div className={`${IsMobileDevice ? "h4 mb-1" : "h5-regular"} ${IsDarkMode ? "" : "color-changepassword-fields-heading"} `}>Confirm Password *</div>
                                    <TextField
                                        required
                                        type={showConfirmPassword ? "text" : "password"}
                                        fullWidth
                                        name="confirmPassword"
                                        value={confirmPassword}
                                        onChange={(e) => {
                                            handleChange(e.target.name, e.target.value); setConfirmPassword(e.target.value)
                                        }}
                                        variant="outlined"
                                        inputProps={{ maxLength: 20 }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position='end' onClick={onClickShowConfirmPassword} className="c-pointer">
                                                    {showConfirmPassword ? <HidePassword /> : <ShowPassword />}
                                                </InputAdornment>
                                            )
                                        }}
                                        FormHelperTextProps={{
                                            className: `h6-regular ${IsMobileDevice && "h5-regular"}`,
                                        }}
                                        size="small"
                                        className="disableEdgeIcon"
                                    />
                                    <FormHelperText className={` h5 color-primary-danger t-align-right ${errors.confirmPassword ? "mb-1" : "mb-4"} `}>
                                        {errors.confirmPassword}
                                    </FormHelperText>

                                    <Grid xs={12} item>
                                        <ButtonComponent
                                            ButtonLabel={ActionLabels.CHANGE_PASSWORD}
                                            Type={"submit"}
                                            ClassName={`c-pointer w-p-100 mb-2 d-flex justify-center ${IsMobileDevice ? "h2" : "h4-regular "
                                                }`}
                                            Variant={
                                                isFormValid()
                                                    ? "disabled-btn-small"
                                                    : "primary-btn-small"
                                            }
                                            Loading={isLoading}
                                        />
                                        <ButtonComponent Variant="secondary-btn" ClassName={`c-pointer w-p-100 h4-regular mt-2`} OnClick={handleCancel} ButtonLabel={buttonLabels.CANCEL} />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </form>
                ) : (
                    <DisplayContent
                        btnClass={
                            "c-pointer d-block primary-btn justify-center f-custom-menuitem d-flex"
                        }
                        displayMsgClass={"h1-medium color-login-headers"}
                        cardTitleClass={`${IsMobileDevice ? "h1" : "h1-semibold"}`}
                        displayIcon={SuccessIcon}
                        cardTitle={appNote.PASSWORD_CHANGED}
                        displayMsg={appNote.CHANGEPASSWORD_SUCESS}
                        btnLabel={buttonLabels.BACK_TO_CONV_TEAMS}
                        btnPath={
                            AppRoutes.CONVERSATIONS
                        }
                        IsMobileDevice={IsMobileDevice}
                    />
                )}
            </div>
        </div>
    );
}
export default ChangePassword;
